import * as React from 'react';
import { BreadCrumbs as BreadCrumbsComponent } from '../../components/BreadCrumbs';
import { useSelector } from 'react-redux';
import { breadcrumbsSelector } from '../../selectors/newbuilding';

export const BreadCrumbs = (): React.JSX.Element | null => {
  const breadCrumbs = useSelector(breadcrumbsSelector);

  if (breadCrumbs.length === 0) {
    return null;
  }

  return <BreadCrumbsComponent breadCrumbs={breadCrumbs} />;
};
